import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { withTranslate } from 'shared/hocs/withTranslate';
import BestSTOIcon from 'shared/assets/images/best_sto.png';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './StoAwards.css';

class StoAwards extends React.Component {
  static propTypes = {
    awards: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    customPopupStyle: PropTypes.string,
    customStyle: PropTypes.string,
    //
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    customPopupStyle: '',
    customStyle: '',
  };

  state = {
    showModal: false,
    condition: null,
  };

  _onClick() {
    this.setState({
      condition: true,
    });
  }

  render() {
    const { awards, customStyle, customPopupStyle, t } = this.props;
    const titleKey = t('locale') === 'uk' ? 'title_uk' : 'title';

    return (
      <div className={cx(s.root, customStyle)} onClick={e => e.preventDefault()}>
        {awards.map(item => (
          <div className={s.bestStoItem} key={item.nomination.id}>
            <a data-tip={`"${item.nomination[titleKey]} ${item.year}"`}>
              <img src={BestSTOIcon} alt={item.nomination[titleKey]} />
              <ReactTooltip place="top" type="light" effect="solid" condition={false} clickable className={cx(s.customToolTip, customPopupStyle)} />
            </a>
          </div>
        ))}
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(StoAwards));



// WEBPACK FOOTER //
// ./src/shared/components/StoAwards/StoAwards.js